<template>
<div>
    <page-title-bar></page-title-bar>

    <v-container fluid grid-list-xl pt-0>
        <page-tool-bar
            show_date_start
            show_date_end
            show_search
            show_building
            :loading="loader"
            :search.sync="search"
            :date_start.sync="date_start"
            :date_end.sync="date_end"
            :chosen_building.sync="chosen_building"
        >
            <v-flex shrink>
                <dialog-tao-phieu @getData="getData++"></dialog-tao-phieu>
            </v-flex>
            <v-flex shrink class="px-0">
                <v-btn
                    :disabled="loader"
                    @click="print++"
                    color="primary"
                >
                    <v-icon small left>print</v-icon>
                    In phiếu thay đổi
                </v-btn>
            </v-flex>
        </page-tool-bar>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <v-card>
                    <data-table
                        :print="print"
                        :date_start="date_start"
                        :date_end="date_end"
                        :search="search"
                        :getDataProp="getData"
                        :loader="loader"
                        @loading="loader = $event"
                        :chosen_building="chosen_building"
                    >
                    </data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>

import DialogTaoPhieu from "./DialogTaoPhieuThayDoiThongTin"
import DataTable from './TablePhieuThayDoiThongTin'
import moment from 'moment'
export default {
    name: "phieu-thay-doi-thong-tin-layout",
    components: {
        DialogTaoPhieu,
        DataTable
    },
    data(){
        return {
            getData: 0,
            print: 0,
            dialog: false,
            loader: false,
            search: '',
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substr(0, 10),
            chosen_building: ""
        }
    },
}
</script>

<style scoped>
    table {
        border-collapse: collapse;
        width: 80%;
        max-width: 800px
    }
    th {
        padding: 8px;
        border-bottom: 1px solid #ddd;
    }
    td {
        padding: 6px
    }
    .cell-fit {
        width:1%;
        white-space:nowrap;
    }
    .border-top {
        padding-top: 9px;
        border-top: 1px solid #ddd;
    }
    .hightlight-row {
        background-color: #ddfbe6;
    }
</style>